import mixpanel from 'mixpanel-browser';
const hostname = window.location.hostname
let localBool = hostname.indexOf("localhost")>-1
let devBool = hostname.indexOf("devportal")>-1
let qaBool = hostname.indexOf("qaportal")>-1

const mixpanel_init = localBool || devBool || qaBool? '35be2abf69f89a339701beda7d754376':'f23143058beb269d43293f07cb2a8d2d'

mixpanel.init(mixpanel_init);


export const Mixpanel = mixpanel;
